const ensureMetaTag = (attributeName, attributeValue) => {
  if (typeof document === 'undefined') return null;
  let tag = document.querySelector(`meta[${attributeName}='${attributeValue}']`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attributeName, attributeValue);
    document.head.appendChild(tag);
  }
  return tag;
};

export const upsertMetaTag = (attributeName, attributeValue, content) => {
  const tag = ensureMetaTag(attributeName, attributeValue);
  if (!tag) return;
  tag.setAttribute('content', content);
};

export const upsertCanonical = (href) => {
  if (typeof document === 'undefined') return;
  let link = document.querySelector("link[rel='canonical']");
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

export const upsertJsonLd = (id, payload) => {
  if (typeof document === 'undefined') return;
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(payload);
};

export const removeJsonLd = (id) => {
  if (typeof document === 'undefined') return;
  const script = document.getElementById(id);
  if (script) script.remove();
};

export const toMetaDescription = (value, fallback) => {
  const cleaned = String(value || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!cleaned) return fallback;
  if (cleaned.length <= 158) return cleaned;
  return `${cleaned.slice(0, 155).trimEnd()}...`;
};